import { createTheme } from "@mui/material/styles";

const defaultInputFontSize = "14px";

const theme = createTheme({
  components: {
    MuiButton: {
      defaultProps: {
        size: "small",
      },
    },
    MuiFilledInput: {
      defaultProps: {
        margin: "dense",
      },
    },
    MuiFormControl: {
      defaultProps: {
        margin: "dense",
      },
    },
    MuiFormHelperText: {
      defaultProps: {
        margin: "dense",
      },
    },
    MuiIconButton: {
      defaultProps: {
        size: "small",
      },
    },
    MuiInputBase: {
      defaultProps: {
        margin: "dense",
      },
    },
    MuiInputLabel: {
      defaultProps: {
        margin: "dense",
      },
    },
    MuiListItem: {
      defaultProps: {
        dense: true,
      },
    },
    MuiMenuItem:{
      defaultProps:{
        dense: true
      }
    },
    MuiOutlinedInput: {
      defaultProps: {
        margin: "dense",
      },
    },
    MuiFab: {
      defaultProps: {
        size: "small",
      },
    },
    MuiTable: {
      defaultProps: {
        size: "small",
      },
    },
    MuiTextField: {
      defaultProps: {
        margin: "dense",
        size: "small"
      },
    },
    MuiToolbar: {
      defaultProps: {
        // variant: 'dense'
      },
    },
    MuiSelect: {
      defaultProps:{
        // margin: "dense",
        size: "small"
      },
      styleOverrides: {
        root: {
          "& .MuiSelect-select": {
            fontSize: defaultInputFontSize
          }
        }
      }
    }
  }
});

export default theme;
